module.exports = __webpack_public_path__ + "img/banner.b2f0b657.png";